<template>
  <div class="box-content">
    <h3 class="block-title">{{ title }}</h3>
    <div class="uppercase">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'box',
  props: {
    title: {
      type: String
    }
  }
}
</script>
